import React from 'react';
import AppFormLabel from './AppFormLabel';
import cx from './cx';
import '../../styles/app-ui.scss';

export function textLength(value) {
  return Array.from(String(value ?? '')).length;
}

/** idle | warn (proche du plafond) | over (dépassement). */
export function charCountTone(length, max) {
  const limit = Number(max);
  if (!Number.isFinite(limit) || limit <= 0) return 'idle';
  if (length > limit) return 'over';
  if (length >= Math.ceil(limit * 0.9)) return 'warn';
  return 'idle';
}

const AppFormField = ({
  label,
  htmlFor,
  required = false,
  help,
  helpExample,
  error,
  hint,
  charValue,
  charMax,
  className = 'mb-3',
  children,
}) => {
  const showCount = Number(charMax) > 0;
  const length = showCount ? textLength(charValue) : 0;
  const tone = showCount ? charCountTone(length, charMax) : 'idle';
  const countId = showCount && htmlFor ? `${htmlFor}-count` : undefined;
  const field = showCount && countId && React.isValidElement(children)
    ? React.cloneElement(children, {
      'aria-describedby': [children.props['aria-describedby'], countId].filter(Boolean).join(' ') || undefined,
      'aria-invalid': tone === 'over' ? true : children.props['aria-invalid'],
    })
    : children;

  return (
    <div className={cx('app-form-field', className, tone === 'over' && 'app-form-field--over')}>
      {label ? (
        <AppFormLabel htmlFor={htmlFor} required={required} help={help} helpExample={helpExample}>
          {label}
        </AppFormLabel>
      ) : null}
      {field}
      {hint ? <div className="form-text">{hint}</div> : null}
      {showCount ? (
        <div className="app-form-field__count">
          <span
            id={countId}
            className={cx('app-char-count', tone !== 'idle' && `app-char-count--${tone}`)}
            aria-live="polite"
            aria-label={
              tone === 'over'
                ? `${length} caractères sur ${charMax}, limite dépassée`
                : `${length} caractères sur ${charMax}`
            }
          >
            {length}/{charMax}
          </span>
        </div>
      ) : null}
      {error ? <div className="invalid-feedback d-block">{error}</div> : null}
    </div>
  );
};

export default AppFormField;
